module.exports = __webpack_public_path__ + "static/img/serviceImg.d5b44de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceExperience/serviceImg.png
// module id = 4ZmN
// module chunks = 1